/**
 * Web app version injected at build/dev time (see vite.config.mjs).
 * Override with REACT_APP_VERSION in env/CI when needed.
 */
export const APP_VERSION = process.env.REACT_APP_VERSION || '0.0.0'
